import { Link } from "react-router-dom";
import Navbar from "./Navbar";

/**
 * Page that is rendered when the page the user is looking for isn't found
 * @returns a page asking the user to go home
 */
const NotFound = () => {
  return (
    <div className="h-screen flex flex-col">
      <Navbar />
      <div className="flex items-center justify-center w-screen flex-1 bg-indigo-500">
        <div className="px-4 sm:px-20 py-10 md:px-40 md:py-20 bg-white rounded-md shadow-xl">
          <div className="flex flex-col items-center">
            <h1 className="font-bold text-indigo-500 text-9xl">404</h1>
            <h6 className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
              <span className="text-red-500">Oops!</span> Page not found
            </h6>
            <p className="mb-8 text-center text-gray-500 md:text-lg">
              The page you’re looking for doesn’t exist.
            </p>
            <Link to="/">
              <button className="outline outline-indigo-500 font-semibold outline-2 hover:bg-indigo-500 text-sm rounded-sm text-center py-2 px-6">
                Go Home
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
